(function () {
  // ===== CONFIG (edit as needed) =====
  const RATE_LOW  = 0.40;   // 50%
  const RATE_HIGH = 0.50;   // 70%

  // Prevent double init
  let initializedRoots = new WeakSet();

  function formatMoney(n, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency, maximumFractionDigits: 2
      }).format(n);
    } catch {
      return `$${n.toFixed(2)}`;
    }
  }

  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel) || []); }

  function findCheckoutButtons(root) {
    return qsa(root, [
      'button[name="checkout"]',          // Dawn primary
      'button[data-checkout-button]',     // some Dawn variants
      'a[href$="/checkout"]',             // anchor fallback
      '.cart__checkout-button',           // legacy class
      '#CartDrawer-Checkout'              // forks
    ].join(','));
  }

  function setCheckoutEnabled(root, enabled) {
    findCheckoutButtons(root).forEach(btn => {
      const isButton = btn.tagName.toLowerCase() === 'button';
      if (isButton) {
        btn.disabled = !enabled;
        btn.setAttribute('aria-disabled', String(!enabled));
      } else {
        if (!enabled) {
          btn.dataset.disabled = 'true';
          btn.style.pointerEvents = 'none';
          btn.style.opacity = '0.5';
        } else {
          delete btn.dataset.disabled;
          btn.style.pointerEvents = '';
          btn.style.opacity = '';
        }
      }
    });
  }

  function initIn(root) {
    if (!root) return;

    const consent = root.querySelector('#us-tariff-consent');
    if (!consent) return;                           // US-only block may not be present

    if (initializedRoots.has(consent)) return;      // already wired
    initializedRoots.add(consent);

    const checkbox = consent.querySelector('#us-tariff-checkbox');
    const errorEl  = consent.querySelector('#us-tariff-error');
    const currency = consent.getAttribute('data-currency') || (window.Shopify?.currency?.active) || 'USD';
    const subtotal = (parseInt(consent.getAttribute('data-subtotal-cents') || '0', 10) || 0) / 100;
    const estimateEl = consent.querySelector('#tariff-estimate-range');

    // Render estimate
    if (subtotal > 0 && estimateEl) {
      const low = subtotal * RATE_LOW, high = subtotal * RATE_HIGH;
      estimateEl.textContent = (RATE_LOW === RATE_HIGH)
        ? formatMoney(low, currency)
        : `${formatMoney(low, currency)} – ${formatMoney(high, currency)}`;
    }

    // Gate initially
    setCheckoutEnabled(root, !!(checkbox && checkbox.checked));

    // Toggle gate
    checkbox && checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        errorEl && errorEl.setAttribute('hidden', '');
        setCheckoutEnabled(root, true);
      } else {
        setCheckoutEnabled(root, false);
      }
    });

    // Intercept submit on the drawer form (mobile drawer uses this)
    const form = root.querySelector('#CartDrawer-Form') || document.getElementById('CartDrawer-Form');
    if (form) {
      // capture phase to beat other handlers
      form.addEventListener('submit', (e) => {
        if (!checkbox?.checked) {
          e.preventDefault();
          errorEl && errorEl.removeAttribute('hidden');
          consent.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true);
    }

    // Intercept button/link clicks (some themes navigate without a submit)
    findCheckoutButtons(root).forEach(btn => {
      btn.addEventListener('click', (e) => {
        const blocked = (btn.tagName.toLowerCase() === 'button' && btn.disabled) || btn.dataset.disabled === 'true';
        if (!checkbox?.checked || blocked) {
          e.preventDefault();
          errorEl && errorEl.removeAttribute('hidden');
          consent.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, { passive: false });
    });
  }

  function attachAll() {
    // Drawer container in Dawn
    const drawer = document.getElementById('CartDrawer');
    initIn(drawer || document);
  }

  // Run on initial load
  document.addEventListener('DOMContentLoaded', attachAll);

  // Re-run whenever Dawn reloads sections (cart updates, open drawer, etc.)
  document.addEventListener('shopify:section:load', attachAll);
  document.addEventListener('shopify:section:unload', attachAll);
  document.addEventListener('cart:refresh', attachAll);

  // Mobile safety net: observe drawer subtree for re-renders
  const observer = new MutationObserver(() => attachAll());
  const startObserver = () => {
    const drawer = document.getElementById('CartDrawer');
    observer.disconnect();
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });
  };
  document.addEventListener('DOMContentLoaded', startObserver);
  document.addEventListener('shopify:section:load', startObserver);
})();
